/**
 * The list-toolbar search field, extracted from ListView so the Posteingang uses the same
 * one. Controlled when `onChange` is given, otherwise uncontrolled (ListView's old behaviour).
 */
import { Search } from 'lucide-react';

interface SearchBoxProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export function SearchBox({ value, onChange, placeholder, ariaLabel }: SearchBoxProps) {
  return (
    <div className="flex h-9 max-w-sm flex-1 items-center gap-2 rounded-md border border-border bg-background px-2.5 text-sm">
      <Search className="size-4 text-muted-foreground" />
      <input
        placeholder={placeholder}
        // Explicit label only: one copied from the placeholder collides with screens' own fields.
        {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
        {...(onChange ? { value: value ?? '', onChange: (e) => onChange(e.target.value) } : {})}
        className="flex-1 bg-transparent text-foreground outline-none placeholder:text-muted-foreground"
      />
    </div>
  );
}
